"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationStatusToJSON = exports.ReservationStatusFromJSONTyped = exports.ReservationStatusFromJSON = exports.ReservationStatus = void 0;
/**
 * The status of the reservation.
 *
 * CANCELLED: The reservation has been cancelled.
 * CONFIRMED: The reservation has been booked and a flight is associated with it.
 * EXPIRED: The reservation has expired.
 * HELD: The advertiser has approved the date(s) and the reservation is held.
 * PENDING: The dates are requested, but reservation is pending approval by the advertiser.
 * SPOTIFY_HELD: The dates are reserved by Spotify.
 * UNSET_RESERVATION_STATUS: The reservation status is not set.
 *
 * @export
 */
exports.ReservationStatus = {
    Archived: 'ARCHIVED',
    Cancelled: 'CANCELLED',
    Confirmed: 'CONFIRMED',
    Expired: 'EXPIRED',
    Held: 'HELD',
    Pending: 'PENDING',
    SpotifyHeld: 'SPOTIFY_HELD',
    UnsetReservationStatus: 'UNSET_RESERVATION_STATUS'
};
function ReservationStatusFromJSON(json) {
    return ReservationStatusFromJSONTyped(json, false);
}
exports.ReservationStatusFromJSON = ReservationStatusFromJSON;
function ReservationStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ReservationStatusFromJSONTyped = ReservationStatusFromJSONTyped;
function ReservationStatusToJSON(value) {
    return value;
}
exports.ReservationStatusToJSON = ReservationStatusToJSON;
